import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import ValidatedTextInput from 'src/components/inputs/validatedTextInput';
import Button from 'src/components/buttons/button';
import { trackEvent, trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import { Field, reduxForm } from 'redux-form';
import { required, minLength, maxLength, email as emailField } from 'src/utils/validators';
import { signup, isEmailAvailable } from 'src/modules/shared/auth/actions';
import { showModal, closeModal } from 'src/modules/shared/modal/actions';
import SignupSurvey from 'src/modules/shared/modal/components/signup/signupSurvey';
import i18n from 'i18next';

export class SignupForm extends React.Component {
  static propTypes = {
    mountedEventAction: PropTypes.string,
    buttonText: PropTypes.string,
    displayDeclarationAndTermsText: PropTypes.bool,
    signupContext: PropTypes.object,
  };

  static defaultProps = {
    displayKeepLogged: true,
    groupCode: '',
    // Event props
    mountedEventAction: 'Displayed registration form',
    displayDeclarationAndTermsText: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: false,
    };
  }

  componentWillMount() {
    trackEvent('Account', this.props.mountedEventAction);
  }

  componentDidMount() {
    // The focus is uncomfortable for small screen
    if (document.documentElement.clientWidth > 768 && this.refs.username) {
      ReactDOM.findDOMNode(this.refs.username).focus();
    }
  }

  getFields = () => {
    return [
      {
        name: 'email',
        placeholder: i18n.t('example@email.com'),
        type: 'email',
        label: i18n.t('Email:'),
        labelExtra: i18n.t('(never publicly displayed)'),
        validate: [
          required(i18n.t('Email is required')),
          emailField(i18n.t('Enter a valid email, e.g. "john@email.com"')),
          maxLength(100),
        ],
        id: 'email',
      },
      {
        name: 'password',
        placeholder: i18n.t('create a password'),
        label: i18n.t('Password:'),
        type: 'password',
        validate: [
          required(i18n.t('Password is required')),
          minLength(6, i18n.t('Passwords must be at least %1$s characters long').replace('%1$s', 6)),
        ],
        id: 'password',
      },
    ];
  };

  onSubmit = async ({ email, password }) => {
    const { groupCode, signupContext, showModal, isEmailAvailable } = this.props;
    const context = {
      ...signupContext,
      groupCode,
    };

    this.setState({ errorMessage: false });

    const { isAvailable } = await isEmailAvailable(email);
    if (!isAvailable) {
      this.setState({ errorMessage: true });
      trackFootfallEvent(footfallEventTypes.CLICKED, {
        clickType: 'join-email-taken',
      });
      return;
    }
    trackFootfallEvent(footfallEventTypes.CLICKED, {
      clickType: 'join-email',
    });
    return showModal(
      <SignupSurvey
        closeModal={this.props.closeModal}
        onFinish={async ({ username }) => {
          await this.props.signup({ password, username, email }, context);
          this.props.onSignupSuccess();
        }}
      />,
    );
  };

  render() {
    const { submitting } = this.props;
    const fields = this.getFields();
    return (
      <form
        className="signup-form"
        role="form"
        onSubmit={this.props.handleSubmit(this.onSubmit)}
      >
        {fields.map((field, i) => (
          <Field
            key={i}
            {...field}
            component={ValidatedTextInput}
          />
        ))}
        {this.state.errorMessage && (
          <div className="input--text__validation-warning" >
            There was a problem creating this account.
            {' '}
            Please <a href="https://support.healthunlocked.com/" target="_blank" >contact support</a>
            {' '}
            for more information
          </div>
        )}
        <Button
          disabled={submitting}
          fullWidth={true}
          isSubmit={true}
          text={this.props.buttonText || i18n.t('Sign up with email')}
        />
      </form>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      signup,
      showModal,
      closeModal,
      isEmailAvailable,
    },
    dispatch,
  );
}

const ConnectedComponent = connect(null, mapDispatchToProps)(
  reduxForm({
    form: 'signup',
  })(SignupForm),
);
export default ConnectedComponent;



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup/signupForm.js